import { Skeleton } from '@/components/ui/skeleton';

/**
 * Loading skeleton for ReadingView that mimics the appearance of Bible text
 * with section titles and paragraphs
 */
export function ReadingViewSkeleton() {
    return (
        <div className="flex flex-col gap-6 p-4 sm:p-6">
            {/* First section */}
            <div className="space-y-3">
                {/* Section title */}
                <Skeleton className="h-7 w-64 mb-4 bg-muted" />

                {/* Paragraph 1 */}
                <div className="space-y-2">
                    <Skeleton className="h-4 w-full bg-muted" />
                    <Skeleton className="h-4 w-full bg-muted" />
                    <Skeleton className="h-4 w-[95%] bg-muted" />
                    <Skeleton className="h-4 w-full bg-muted" />
                    <Skeleton className="h-4 w-[88%] bg-muted" />
                </div>

                {/* Paragraph 2 */}
                <div className="space-y-2 mt-4">
                    <Skeleton className="h-4 w-full bg-muted" />
                    <Skeleton className="h-4 w-[92%] bg-muted" />
                    <Skeleton className="h-4 w-full bg-muted" />
                    <Skeleton className="h-4 w-[85%] bg-muted" />
                </div>
            </div>

            {/* Second section */}
            <div className="space-y-3">
                {/* Section title */}
                <Skeleton className="h-7 w-56 mb-4 bg-muted" />

                {/* Paragraph 3 */}
                <div className="space-y-2">
                    <Skeleton className="h-4 w-full bg-muted" />
                    <Skeleton className="h-4 w-full bg-muted" />
                    <Skeleton className="h-4 w-[90%] bg-muted" />
                    <Skeleton className="h-4 w-full bg-muted" />
                    <Skeleton className="h-4 w-full bg-muted" />
                    <Skeleton className="h-4 w-[93%] bg-muted" />
                </div>

                {/* Paragraph 4 */}
                <div className="space-y-2 mt-4">
                    <Skeleton className="h-4 w-full bg-muted" />
                    <Skeleton className="h-4 w-[87%] bg-muted" />
                    <Skeleton className="h-4 w-full bg-muted" />
                </div>
            </div>

            {/* Third section */}
            <div className="space-y-3">
                {/* Section title */}
                <Skeleton className="h-7 w-72 mb-4 bg-muted" />

                {/* Paragraph 5 */}
                <div className="space-y-2">
                    <Skeleton className="h-4 w-full bg-muted" />
                    <Skeleton className="h-4 w-full bg-muted" />
                    <Skeleton className="h-4 w-[96%] bg-muted" />
                    <Skeleton className="h-4 w-full bg-muted" />
                    <Skeleton className="h-4 w-[89%] bg-muted" />
                    <Skeleton className="h-4 w-full bg-muted" />
                    <Skeleton className="h-4 w-[91%] bg-muted" />
                </div>

                {/* Paragraph 6 */}
                <div className="space-y-2 mt-4">
                    <Skeleton className="h-4 w-full bg-muted" />
                    <Skeleton className="h-4 w-full bg-muted" />
                    <Skeleton className="h-4 w-[84%] bg-muted" />
                </div>
            </div>

            {/* Fourth section */}
            <div className="space-y-3">
                {/* Section title */}
                <Skeleton className="h-7 w-60 mb-4 bg-muted" />

                {/* Paragraph 7 */}
                <div className="space-y-2">
                    <Skeleton className="h-4 w-full bg-muted" />
                    <Skeleton className="h-4 w-[94%] bg-muted" />
                    <Skeleton className="h-4 w-full bg-muted" />
                    <Skeleton className="h-4 w-full bg-muted" />
                    <Skeleton className="h-4 w-[86%] bg-muted" />
                </div>
            </div>
        </div>
    );
}

